export const environment = {
  production: false,
  apiScope:
    'https://KHSoftwareTest.onmicrosoft.com/f8e71cdb-d899-4597-bd8e-2374e0edfe45/user_impersonation',
  clientId: '22159355-8824-4b38-b432-738538562069',
  authority:
    'https://login.microsoftonline.com/d6a0d937-db2d-45df-9161-8da8d5e140ec',
  mapbox: {
    accessToken:
      'pk.eyJ1IjoibWFsb3JpZW1leWVycyIsImEiOiJjbDVhOXE4NzMyMWNqM2xuczBjZ3FlcXh3In0.jnQWr29B44kAweW0DRhpuw',
  },
  aggrid: {
    licenseKey:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-120083}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Kimley_Horn}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{12_February_2027}____[v3]_[01]_MTgwMjM5MDQwMDAwMA==7b23a65ddac8d6dae2e4c8466daa9ad8',
  },
  version: '1.0.0',
  helpEmail: 'traction@kimley-horn.com',
}
